/**
 * React Query keys for charters. Standalone so the schedule (which reads) and the create form
 * (which invalidates) share them without importing each other.
 */
export const charterQueryKeys = {
	/** Everything charter — what saving invalidates, whatever week is on screen. */
	all: ['charters'] as const,

	/** The charters for one window of the schedule. */
	schedule: (startDate: string, numOfDays: number) => ['charters', 'schedule', startDate, numOfDays] as const,

	/** One charter, for the detail sidebar. */
	detail: (id: string) => ['charters', 'detail', id] as const,

	/**
	 * One page of the charters table, for the customer, filters and paging that produced it.
	 *
	 * `userId` is 'all' for the staff-wide table on /staff-bookings and the customer's id for the
	 * copy on their page — without it in the key the two would share a cache entry and serve each
	 * other's rows.
	 *
	 * The filters go into the key whole rather than field by field: the table's store owns which
	 * fields there are, and a key naming them would have to be edited every time one is added — a
	 * miss there serves the previous filter's rows under the new filter and nothing throws.
	 */
	list: (userId: string | undefined, filters: unknown, perPage: number) =>
		['charters', 'list', userId ?? 'all', filters, perPage] as const,

	/** The signed-in customer's own booked charters, for their bookings list. */
	mine: ['charters', 'mine'] as const,

	/** One of the customer's own charters, for their charter view. */
	mineDetail: (id: string) => ['charters', 'mine', id] as const,
};
